import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'

export const TitlePieChart = ({ title, isI18n }) => {
  return (
    <Element
      elementName="span"
      style={{ color: '#191d25', fontWeight: 600, marginLeft: 28 }}
    >
      {isI18n ? <Translate value={title} /> : title}
    </Element>
  )
}

TitlePieChart.propTypes = {
  title: PropTypes.string.isRequired,
  isI18n: PropTypes.bool,
}

TitlePieChart.defaultProps = {
  isI18n: true,
}
